import { connect } from 'react-redux';
import { clearScoreCard } from '@Actions/scoreCardActions';
import { logout, isCurrentSystemExpired } from '@Actions/authentication';
import ConfigComponent from './ConfigComponent';

const mapStateToProps = ({ auth }) => ({
    activeSystem: auth.activeSystem
});

export default connect(
    mapStateToProps,
    { clearScoreCard, logout, isCurrentSystemExpired }
)(ConfigComponent);
